import { render, staticRenderFns } from "./CertificationsTermsEdit.vue?vue&type=template&id=691eb264&"
import script from "./CertificationsTermsEdit.vue?vue&type=script&lang=js&"
export * from "./CertificationsTermsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports